/**
 * Restrict historical rows to the currently in-scope account/holding IDs.
 * `undefined` means scope is not ready yet, so the original list is kept.
 */
export function filterByInScopeIds<T>(
  records: T[],
  getId: (record: T) => number | null | undefined,
  inScopeIds: Set<number> | undefined,
): T[] {
  if (inScopeIds === undefined) {
    return records;
  }

  return records.filter((record) => {
    const id = getId(record);
    return id != null && inScopeIds.has(id);
  });
}
